/**
 * 文字列の最大文字数制限
 * @param max 最大文字数
 * @param text エラーメッセージ
 * @returns {Function}
 */
export const strMax = (max, text) => (value) => {
    if (typeof value === 'string' && value.length > max) {
        return text;
    }
    return '';
};
/**
 * 文字列の最小チェック
 * @deprecated TS化済 src/utils/validate/conditions/strLength.ts
 * @param num 最小文字数
 * @param text エラーメッセージ
 * @returns {Function}
 */
export const strMin = (num, text) => (value) => {
    if (typeof value === 'string' && value.length > 0 && value.length < num) {
        return text;
    }
    return '';
};
